import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { ManagerReportTdcfComponent } from './manager-report.tdcf.component';
import { PrintPreviewTdcfComponent } from './print-preview.tdcf.component';
import { TdcfComponent } from './tdcf.component';

export const TdCfFormRoutes: Routes = [
    {
        path: 'td-qtr-check-in',
        canActivate: [AuthService],
        canActivateChild: [AuthService],
        children: [
            {
                path: '',
                component: TdcfComponent,
            },
            {
                path: 'print-preview',
                component: PrintPreviewTdcfComponent,
            },
        ],
    },
    {
        path: 'reports',
        canActivate: [AuthService],
        canActivateChild: [AuthService],
        children: [
            {
                path: 'td-qtr-check-in/manager',
                component: ManagerReportTdcfComponent,
                data: { directTeamOnly: true },
            },
            {
                path: 'td-qtr-check-in/upper',
                component: ManagerReportTdcfComponent,
                data: { directTeamOnly: false },
            },
        ],
    },
    {
        path: 'print-preview/td-qtr-check-in',
        canActivate: [AuthService],
        component: PrintPreviewTdcfComponent,
    },
];
